import { Location } from 'graphql/generated/graphqlTypes';
import { getAllAccessGrantsOfVisitorGroup, VisitorGroupAccessIds } from 'utils/VisitorGroup/VisitorGroup';

export const getLockGroupsThatHaveVisitorGroupAssigned = (
  visitorGroups: VisitorGroupAccessIds[],
  visitorGroupId: string
) => {
  const filteredVisitorGroup = visitorGroups.find((visitorGroup) => visitorGroup.id === visitorGroupId);
  if (filteredVisitorGroup) {
    const allAccessGrantOfSelectedVisitorGroup = getAllAccessGrantsOfVisitorGroup(filteredVisitorGroup);
    return allAccessGrantOfSelectedVisitorGroup.flatMap((accessGrant) => accessGrant.locations);
  }
  return [];
};

export const getLockGroupsThatHaveLockAssigned = (lockGroups: Location[], lockId: string) => {
  return lockGroups.filter((lockGroup) => lockGroup.doors.some((door) => door.id === lockId));
};

export const getLockGroupAssignedToVisitor = (
  locations: Location[],
  visitorGroupsContainingVisitor: VisitorGroupAccessIds[]
) => {
  const allLocationsAssignedToVisitor = visitorGroupsContainingVisitor?.flatMap((group) =>
    group.accessGrants.flatMap((accessGrant) => accessGrant.locations.flatMap((location) => location.id))
  );
  return locations.filter((location) =>
    allLocationsAssignedToVisitor?.some((locationId) => locationId === location.id)
  );
};
